<template>
    <div>
        <div class="search-btn">
            <div>
                <el-button size="small" type="primary"
                           v-if="$store.getters.checkChangeAuth()" @click="batchStart" :disabled="multipleSelection.length === 0">批量启用
                </el-button>
                <el-button size="small" type="primary"  v-if="$store.getters.checkChangeAuth()" @click="batchStop" :disabled="multipleSelection.length === 0">
                    批量停用
                </el-button>
                <el-button size="small" type="primary"  v-if="$store.getters.checkChangeAuth()" @click="batchSetNation" :disabled="multipleSelection.length === 0">
                    批量分配国家
                </el-button>
                <el-select v-model="currentBrand" size="small" placeholder="请选择品牌" style="margin-left: 30px;" @change="handleBrandChange">
                    <el-option
                            v-for="item in brandList"
                            :key="item"
                            :label="item"
                            :value="item">
                    </el-option>
                </el-select>
            </div>
        </div>

        <div v-if="info.success" class="device-case border-all">
            <el-table ref="multipleTable" :data="info.list" :header-cell-style="{backgroundColor: '#efefef'}" stripe
                      size="mini" :height="tableHeight" @selection-change="handleSelectionChange" @row-click="checkRow"
                      tooltip-effect="dark" style="width: 99%; " :row-class-name="rowIndex">
                <el-table-column align="center" header-align="center" type="selection"></el-table-column>
                <el-table-column :formatter="order" label="ID" width="80px"></el-table-column>
                <el-table-column prop="brand" label="品牌"></el-table-column>
                <el-table-column prop="model" label="型号">
                </el-table-column>
                <el-table-column prop="nationIds" label="国家" :show-overflow-tooltip="true" width="120px">
                    <template slot-scope="scope">
            {{scope.row.nationIds | showNationName}}
                    </template>
                </el-table-column>
                <el-table-column prop="isDeleted" label="状态">
                    <template slot-scope="scope">
            <span :style="scope.row | statusClassFilter">
            {{scope.row | statusStr}}
          </span>
                    </template>
                </el-table-column>

            </el-table>
            <div class="list-bottom">
                <div></div>
                <el-pagination
                        @size-change="sizeChangeHandle"
                        @current-change="currentChangeHandle"
                        :current-page="page.startPage"
                        :page-sizes="[10, 20, 50]"
                        :page-size="page.limit"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next"
                        :total="info.total">
                </el-pagination>
            </div>
        </div>
        <Drawer
                title="分配国家"
                :visible.sync="setNationPopShow"
                @handClick="batchNations"
        >
            <div style="font-size: 14px;margin-bottom: 10px;">请选择国家（切换时默认与SIM卡信息绑定）：</div>
            <el-checkbox-group v-model="nationIds" style="display: flex;flex-direction: column">
                <template v-for="item in nationOptions">
                    <el-checkbox
                            :key="item.value"
                            :label="item.value"
                            style="margin: 4px 10px;"
                    >{{ item.label }}
                    </el-checkbox
                    >
                </template>
            </el-checkbox-group>
        </Drawer>
    </div>
</template>

<script>
    import Drawer from '@/components/Drawer'
    import {commonData} from '@/mixin'
    export default {
        name: "PhoneModel",
        components: {
            Drawer
        },
        mixins:[commonData],
        data() {
            return {
                setNationPopShow: false,
                nationIds:[],
                nationOptions: [{
                    label: "美国",
                    value: 3
                }, {
                    label: "英国",
                    value: 4
                },{
                    label: "印度尼西亚",
                    value: 5
                },{
                    label: "泰国",
                    value: 6
                },{
                    label: "马来西亚",
                    value: 7
                },{
                    label: "菲律宾",
                    value: 8
                },{
                    label: "越南",
                    value: 9
                },{
                    label: "日本",
                    value: 10
                }],

                brandList:[],

                fileList: [],
                row: null,
                currentBrand:"",
            }
        },
        filters: {
            statusClassFilter(row) {
                if (row.isDeleted === 'Y') {
                    return {color: "red"};
                } else {
                    return {color: "green"};
                }
            },
            statusStr(row) {
                if (row.isDeleted === 'Y') {
                    return "停用"
                } else {
                    return "启用"
                }
            },
            showNationName(ids) {
                let nationName = []
                if (!ids || ids.length === 0) {
                    return "无"
                } else {
                    let idsArr = ids.split(",")
                    // console.log("idsArr is " + JSON.stringify(idsArr))
                    idsArr.forEach(item=>{
                        // console.log("item is " + item)
                        if (item == 3) {
                            nationName.push("美国")
                        }
                        else if (item == 4) {
                            nationName.push("英国")
                        }
                        else if (item == 5) {
                            nationName.push("印度尼西亚")
                        }else if (item == 6) {
                            nationName.push("泰国")
                        }
                        else if (item == 7) {
                            nationName.push("马来西亚")
                        }else if (item == 8) {
                            nationName.push("菲律宾")
                        }else if (item == 9) {
                            nationName.push("越南")
                        }else if (item == 10) {
                            nationName.push("日本")
                        }
                    })
                    if (nationName.length > 0) {
                        return nationName.join(",")
                    } else {
                        return "无"
                    }
                }
            }
        },
        methods: {
            batchNations() {
                let nationIds = this.nationIds.sort().join(",")
                console.log("nationIds is " + nationIds)
                let ids = []
                for (let item of this.multipleSelection) {
                    ids.push(item.id)
                }
                this.$post(this.$uri.dbPhone.batchNation, {ids, nationIds}).then(res => {
                    if (res.success) {
                        this.getPhoneModelList()
                    }
                })
                this.setNationPopShow = false
            },
            checkRow(r, c, e) {
                this.$refs.multipleTable.toggleRowSelection(r)
            },
            handleSelectionChange(val) {
                this.multipleSelection = val
                // console.log(this.multipleSelection)
            },
            batchStart() {
                // console.log("multiselecttion " + JSON.stringify(this.multipleSelection))
                let ids = []
                for (let item of this.multipleSelection) {
                    ids.push(item.id)
                }
                this.$post(this.$uri.dbPhone.onOff, {ids, isDeleted: 'N'}).then(res => {
                    if (res.success) {
                        this.getPhoneModelList()
                    }
                })
            },
            batchStop() {
                let ids = []
                for (let item of this.multipleSelection) {
                    ids.push(item.id)
                }
                let that = this
                that.$post(that.$uri.dbPhone.onOff, {ids, isDeleted: 'Y'}).then(res => {
                    if (res.success) {
                        that.getPhoneModelList()
                    }
                })
            },
            batchSetNation() {
                this.setNationPopShow = true
            },
            handleBrandChange() {
                this.getPhoneModelListForSearch()
            },
            rowIndex({row, rowIndex}) {
                row.rowIndex = rowIndex;
            },
            order(row) {
                return row.rowIndex + 1;
            },
            /* 获取机型池列表 */
            getPhoneModelList() {
                let params = JSON.parse(JSON.stringify(this.page))
                // console.log("this.searchInfo.proxyNameLike " + this.searchInfo.proxyNameLike )
                if (this.currentBrand.length > 0 && this.currentBrand != "全部品牌") {
                    params.brand = this.currentBrand;
                }
                // console.log("params is " + JSON.stringify(params))
                this.$post(this.$uri.dbPhone.list, params).then(res => {
                    this.info = res
                    // console.log("info is " + JSON.stringify(res))
                    this.$nextTick().then(() => {
                        this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 200;
                    })
                })
            },
            getPhoneModelListForSearch() {
                this.page.startPage = 1
                let params = JSON.parse(JSON.stringify(this.page))
                // console.log("this.searchInfo.proxyNameLike " + this.searchInfo.proxyNameLike )
                if (this.currentBrand.length > 0 && this.currentBrand != "全部品牌") {
                    params.brand = this.currentBrand;
                }
                // console.log("params is " + JSON.stringify(params))
                this.$post(this.$uri.dbPhone.list, params).then(res => {
                    this.info = res
                    // console.log("info is " + JSON.stringify(res))
                    this.$nextTick().then(() => {
                        this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 200;
                    })
                })
            },
            getBrandList() {
                let that = this
                // console.log("params is " + JSON.stringify(params))
                that.$post(that.$uri.dbPhone.listBrand).then(res => {
                    that.brandList = res.list
                    // console.log("res is " + JSON.stringify(res.list))
                    that.brandList.unshift("全部品牌")
                    // console.log("brandList is " + JSON.stringify(that.brandList))
                })
            },
            /* 当前页改变 */
            currentChangeHandle(val) {
                this.page.startPage = val
                this.getPhoneModelList()
            },
            /* 每页条数改变 */
            sizeChangeHandle(val) {
                this.page.limit = val
                this.getPhoneModelList()
            },
        },
        mounted() {
            this.getPhoneModelList()
            this.getBrandList()
        }
    }
</script>

<style lang="less" scoped>
    .list-bottom {
        padding: 10px 8px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .list-bottom-btn {
            display: flex;
            flex-direction: row;
        }
    }
</style>